import styled, { css } from 'styled-components'

import { BasketSVG } from '@src/components/SVGS/BasketSVG'
import { breakpoints } from '@src/constants/breakpoints'

export const Container = styled.button<{
  buttonStyle: 'icon' | 'total'
  isClickable?: boolean
}>`
  padding: 0;
  height: 48px;
  position: relative;
  border-radius: 28px;
  border: none;
  background: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0 10px;
  margin-left: 10px;

  ${({ theme, buttonStyle, isClickable }) => {
    // TODO lol it changes the whole thing on one prop
    if (buttonStyle === 'icon') {
      return css`
        color: #fff;
        font-weight: 700;
        background-color: ${theme.colors.brand};
        transition: 0.3s ease;
        transition-property: color, background-color, border-color;

        ${isClickable
          ? css`
              &:hover:enabled {
                background-color: #fff;
                color: ${theme.colors.brand};
                border-color: #fff;
              }
            `
          : ''}
      `
    }

    return css`
      padding: 0px 12px 0 14px;
      font-weight: 700;
      font-size: 16px;
      color: ${theme.colors.brandForeground};
      background-color: ${theme.colors.brand};
      transition: 0.3s ease;
      transition-property: color, background-color, border-color;

      ${isClickable
        ? css`
            &:hover:enabled {
              background-color: #fff;
              color: ${theme.colors.brand};
              border-color: #fff;
            }
          `
        : ''}

      &:disabled {
        cursor: default;
      }
    `
  }}
`

export const TotalText = styled.p`
  margin-left: 8px;
  @media (min-width: ${breakpoints.tablet}px) {
    margin-left: 12px;
  }
`

export const StyledBasketSVG = styled(BasketSVG)`
  width: 24px;
  height: 24px;
`
